import {createReducer, on} from '@ngrx/store';
import { postBoleto,postedBoleto,clearBoleto } from '../actions/scanBoleto.actions';
import { BoletoState } from 'src/app/core/models/boleto.state';


export const initialState:BoletoState = {loading: false, boleto: null, contBoleto: 0};


export const boletoReducer = createReducer(
  initialState,

  on(postBoleto, (state,{boleto}) => {
    return {...state, loading: true,contBoleto: 0};
  }),
  on(postedBoleto, (state,{boleto}) => {
    return {...state, loading: false, boleto, contBoleto:0};
  }),
  on(clearBoleto, (_) =>{
    return initialState;
  })

);
0
